export function formatNumber(num) {
    if (num < 0) {
        num = -num; // make number positive
        return (Math.round(num * 100) / 100).toFixed(2) + " CR";
    } else {
        return (Math.round(num * 100) / 100).toFixed(2) + " DR";
    }
}

